<div class="hw-box-content">
  <div class="hw-header-wrap">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-6">Audit Detail</div>
        </div>
      </div>
    </div>
  </div>
  <div class="hw-content">
    <div class="row">
      <div class="col-12">
         <ul class="list-inline">
          <li class="align-top width-210px">
            <fn-date-range-picker [startDate]="dateRangeObject.startDate" [futureDateDisabled]="true"
              [maxDate]="maxDateRange" (dateCB)="changeDate($event)" [endDate]="dateRangeObject.endDate">
            </fn-date-range-picker>
          </li>
          <li class="align-top pt">
            <div class="form-check">
              <label class="form-check-label" for="inlineFormCheck">
                Select Entity
              </label>
            </div>
          </li>
          <li class="align-top width-200px">
            <fn-select [labelKey]="'entityName'" [inputKey]="'entityName'" [optionList]="entityArray"
              [placeholder]="'Select Entity'" [(ngModel)]="selectEntity" [ngModelOptions]="{standalone: true}">
            </fn-select>
          </li>           
          <li class="align-top">
            <div class="form-check">
              <label class="form-check-label" for="inlineFormCheck">
                Select Action
              </label>
            </div>
          </li>
          <li class="align-top width-200px">
            <fn-select [labelKey]="'name'" [inputKey]="'name'" [optionList]="actionArray"
          [placeholder]="'Select Action'" [(ngModel)]="selectAction" [ngModelOptions]="{standalone: true}">
        </fn-select>
          </li>
          <li>
          <li class="align-top pt">
            <fn-button [type]="'primary'" [btnClass]="'btn-sm btn-round'" [text]="'GO'"
              (click)="getEntityDetails()"></fn-button>
          </li>
          @if(tableDataArray.length >0){
            <li class="align-top pt">
              <fn-button
                [type]="'success'"
                [btnClass]="'btn-sm btn-round'"
                [text]="'Download CSV'"
                (click)="downloadCsv()"
              ></fn-button>
            </li>
            }
        </ul>
      </div>
    </div>
    <div class="row">
        <div class="col-12">
          <fn-table [config]='config' [rowMetaArray]='rowMetaArray' [dataArray]='tableDataArray' [pageSize]="15"></fn-table>
          </div>
    </div>
</div>
</div>